import { genUuid } from "src/app/utils/uuid";
import { ContentViewExtras, Payload } from "../payloads/view-payloads";


export abstract class ViewTracker implements PublicViewTracker {
  protected isOpen = false;
  protected viewId: string | null = null;
  protected started = false;
  protected finished = false;
  // protected Id: string | null = null;

  protected viewUuid: string | null = null;
  // Sirve para simular una pila y esperar que primero se abra antes de cualquier otra accion
  private openingPromise: Promise<void> | null = null;
  // contexto común
  protected siteVisitUuid: string | null = null;
  // id lógico (sectionId/contentId, etc)
  protected Id: number | null = null;

  constructor(protected name: string) { }

  // public async open(data: Payload, id?: string, extras?: ContentViewExtras): Promise<void> {
  //   if (this.isActive()) return;
  //   // if (!!extras) {
  //   //   this.viewId = await this.create(data);
  //   // }else{
  //   //   this.viewId = await this.create(data);
  //   // }
  //   this.viewId = await this.create(data);
  //   this.Id = id ?? null;
  //   this.isOpen = true;
  //   // console.log(`[${this.name}] Opened with ID:`, this.viewId);
  // }

  public async open(data: any, id?: number, extras?: ContentViewExtras): Promise<void> {
    if (this.isActive()) return;

    // UUID NUEVO por apertura
    this.viewUuid = genUuid();

    // guardar contexto (siteVisitUuid, etc)
    this.onOpenContext(data, extras);

    this.openingPromise = this.create(data, extras);

    try {
      await this.openingPromise;
      this.Id = id ?? null;
      this.isOpen = true;
    } catch (err) {
      this.reset();
      throw err;
    } finally {
      this.openingPromise = null;
    }
  }

  protected onOpenContext(body: any, extras?: ContentViewExtras): void {
    if (body?.siteVisitUuid) this.siteVisitUuid = body.siteVisitUuid;
  }

  public async close(viewId: string | null, body?: any): Promise<void> {
    if (!this.isActive() || !viewId) return;
    // console.log(`[${this.name}] Closed with ID:`, this.viewId);
    if (!!body) {
      await this.closeApi(viewId, body);
    } else {
      await this.closeApi(viewId);
    }
    this.reset();
  }

  public async start(viewId: string | null, body?: any): Promise<void> {
    if (!this.isActive() || !viewId || this.getStarted()) return;
    if (!!body) {
      await this.startApi(viewId, body);
    } else {
      await this.startApi(viewId);
    }
    this.setStarted(true);
    // console.log(`[${this.name}] Start with ID:`, this.viewId);
  }

  public async finish(viewId: string | null, body?: any): Promise<void> {
    if (!this.isActive() || !viewId || this.getFinished() || !this.getStarted()) return;
    if (!!body) {
      await this.finishApi(viewId, body);
    } else {
      await this.finishApi(viewId);
    }
    this.setFinished(true);
    // console.log(`[${this.name}] Finish with ID:`, this.viewId);
  }

  protected reset(): void {
    this.viewId = null;
    this.Id = null;
    this.isOpen = false;
    this.started = false;
    this.finished = false;
  }

  public triggerPing(viewId: string | null, body?: any): void {
    if (!this.isActive() || !viewId) return;
    if (!!body) {
      this.ping(viewId, body);
    } else {
      this.ping(viewId);
    }
    // console.log(`[${this.name}] Ping with ID:`, this.viewId);
  }

  public isActive(): boolean {
    return this.isOpen;
  }

  public getViewId(): string | null {
    return this.viewId;
  }

  public setStarted(started: boolean): void {
    this.started = started;
  }

  public getStarted(): boolean {
    return this.started;
  }

  public setFinished(finished: boolean): void {
    this.finished = finished;
  }

  public getFinished(): boolean {
    return this.finished;
  }

  public getId(): number | null {
    return this.Id;
  }

  // Métodos abstractos: deben implementarlos las clases hijas
  protected abstract create(body: any, extras?: any): Promise<void>;
  protected abstract ping(viewId: string, body?: any): void;
  protected abstract closeApi(viewId: string, body?: any): Promise<void>;
  protected abstract startApi(viewId: string, body?: any): Promise<void>;
  protected abstract finishApi(viewId: string, body?: any): Promise<void>;
  public onExtrasReceived?(extras: ContentViewExtras): void; // Para ContentView solamente
  public getViewUuid(): string | null {
    return this.viewUuid;
  }
}

export interface PublicViewTracker {
  getViewUuid(): string | null;
  getViewId(): string | null;
  getStarted(): boolean;
  getFinished(): boolean;
  getId(): number | null;
  isActive(): boolean;
}
